import cx from 'classnames';
import loadingIcon from '@/assets/images/loader.svg';

import styles from './LoadingIcon.module.sass';

interface LoadingIconProps {
  className?: string;
}

const LoadingIcon = ({ className }: LoadingIconProps) => {
  return (
    <div className={cx(styles.loading, className)}>
      <img src={loadingIcon} alt="Loading..." className={styles.icon} />
    </div>
  );
};

export default LoadingIcon;